import { render, staticRenderFns } from "./FormMotif.vue?vue&type=template&id=2e2428d8&"
import script from "./FormMotif.vue?vue&type=script&lang=js&"
export * from "./FormMotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports